<template>
  <div style="height: 100%">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="列表" name="list">
        <el-form :inline="true" label-width="68px" class="searchListInput">
          <el-form-item label="角色名称" prop="name">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入角色名称"
              clearable
              size="small"
              style="width: 150px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item class="mb8">
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="handleQuery"
              >搜索
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增
            </el-button>
          </el-form-item>
        </el-form>

        <el-table
          height="98%"
          style="width: fit-content"
          v-loading="loading"
          :data="tableData"
          border
          @row-dblclick="handleTableRow"
        >
          <!--                    <el-table-column type="selection" width="55" align="center"/>-->
          <el-table-column
            label="角色名称"
            align="center"
            prop="name"
            width="150"
          />
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdatePermission(scope.row)"
                >权限设置</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination
            v-show="total > 0"
            @size-change="handleQuery"
            @current-change="handleQuery"
            :current-page.sync="queryParams.current"
            :page-sizes="[10, 20, 40, 60, 80, 100]"
            :page-size.sync="queryParams.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="详情" name="detail">
        <el-form :inline="true" label-width="68px" class="searchListInput">
          <el-form-item class="mb8">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-finished"
              size="mini"
              @click="save"
              >保存
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-delete"
              size="mini"
              @click="handleDelete"
              >删除
            </el-button>
          </el-form-item>
        </el-form>

        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="角色名称" prop="name">
                <el-input v-model="form.name" placeholder="角色名称" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { selectList, add, detail, remove } from '../../api/system/role';
import { translateObjectEmptyAttributeToNull } from '../../untils/func';

export default {
  name: 'Spring',
  data() {
    return {
      total: 0,
      activeTab: 'list',
      // 遮罩层
      loading: true,
      // 字典表格数据
      tableData: [],
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        name: '',
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' },
        ],
      },
    };
  },

  created() {
    this.handleQuery();
  },

  methods: {
    async handleQuery() {
      this.loading = true;
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const response = await selectList(param).then();
      this.tableData = response.data;
      this.total = response.total;
      this.loading = false;
    },
    async save() {
      const response = await add(this.form).then();
      const id = response.data;
      this.msgSuccess('保存成功');
      await this.viewDetail(id);
      await this.handleQuery();
    },

    async handleTableRow(row) {
      this.activeTab = 'detail';
      await this.viewDetail(row.id);
    },

    async viewDetail(id) {
      const response = await detail({ id: id }).then();
      this.form = response.data;
    },
    async handleAdd() {
      this.form = {};
      this.activeTab = 'detail';
    },

    async handleDelete() {
      if (this.form.id == undefined) {
        return;
      }
      await this.$confirm('确定要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then();

      await remove(this.form.id).then();
      this.msgSuccess('删除成功');
      await this.handleAdd();
      await this.handleQuery();
    },

    handleUpdatePermission(row) {
      this.$router.push({
        path: '/mainWindow/roleModule',
        query: { roleId: row.id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.el-tabs {
  padding: 0 10px;
  height: 100%;
  .el-tab-pane {
    height: calc(100% - 75px);
  }
}
.elButtonSearch {
  background: #00b741;
  border: 1px solid #00b741;

  &:hover {
    background: #39d636;
    border: 1px solid #39d636;
  }
}

.searchListInput {
  .el-input__inner {
    &::placeholder {
      color: #838689;
    }
  }

  .el-date-editor .el-range-input {
    &::placeholder {
      color: #838689;
    }
  }

  .el-form-item {
    margin-bottom: 0.25rem;
  }
}
</style>
